// The messages in an API error body, for display: a { field: ['message'] } body flattened, with a
// { detail: 'message' } first. Anything that isn't an object (an HTML error page from a proxy, say)
// gives none, so callers show their own fallback.
export function apiErrorMessages(error) {
  const data = error && error.response && error.response.data;
  if (!data || typeof data !== 'object') return [];
  const messages = Object.values(data)
    .flat()
    .filter((value) => typeof value === 'string' && value);
  if (typeof data.detail === 'string' && data.detail) {
    return [data.detail, ...messages.filter((message) => message !== data.detail)];
  }
  return messages;
}

// The first of those messages, or ''.
export function apiErrorMessage(error) {
  return apiErrorMessages(error)[0] || '';
}

export default apiErrorMessage;
